// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "20260924.1790265842/static/js/" + chunkId + "." + {"249":"135f3a8d","463":"8a875d0b"}[chunkId] + ".chunk.js";
};